export default __webpack_public_path__ + "static/media/home-decor-img-02.3b2c1543.png";